var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgConnector4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.47,29.71A27.39,27.39,0,1,0,25.32,56.26V59A2.39,2.39,0,0,0,26,60.68a3.89,3.89,0,0,0,3,1h6.27a3.9,3.9,0,0,0,3-1A2.29,2.29,0,0,0,38.85,59V56.26A27.25,27.25,0,0,0,59.47,29.71ZM37.91,54.91l-.59.14v4a.93.93,0,0,1-.26.6,2.62,2.62,0,0,1-1.84.52H29a2.58,2.58,0,0,1-1.83-.52.93.93,0,0,1-.27-.64v-4l-.59-.14a25.87,25.87,0,1,1,11.65,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.22,62.63H29a4.75,4.75,0,0,1-3.66-1.32,3.28,3.28,0,0,1-.9-2.38V57a28.31,28.31,0,1,1,15.38,0v2a3.23,3.23,0,0,1-.89,2.28A4.76,4.76,0,0,1,35.22,62.63ZM32.09,4.77A24.94,24.94,0,0,0,26.47,54l1.31.31V59a2,2,0,0,0,1.18.23h6.26c.92,0,1.16-.23,1.17-.24V54.32L37.7,54A24.94,24.94,0,0,0,32.09,4.77Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,33.47a4.22,4.22,0,1,0,4.22,4.22A4.22,4.22,0,0,0,19,33.47ZM19,39.62a1.93,1.93,0,1,1,1.94-1.93A1.92,1.92,0,0,1,19,39.62Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.24,28.46a6,6,0,1,0-6-6A6,6,0,0,0,41.24,28.46Zm0-9.11a3.14,3.14,0,1,1-3.14,3.14A3.14,3.14,0,0,1,41.24,19.35Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.18,28.71A6.22,6.22,0,1,0,17,22.49,6.23,6.23,0,0,0,23.18,28.71Zm0-9.36A3.14,3.14,0,1,1,20,22.49,3.14,3.14,0,0,1,23.18,19.35Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.47,38.47a6,6,0,1,0,6,6A6,6,0,0,0,32.47,38.47Zm0,9.11a3.14,3.14,0,1,1,3.14-3.13A3.13,3.13,0,0,1,32.47,47.58Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.17,33.47a4.22,4.22,0,1,0,4.22,4.22A4.22,4.22,0,0,0,45.17,33.47Zm-.06,6.26a2,2,0,1,1,2-2A2,2,0,0,1,45.11,39.73Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,35.76a1.93,1.93,0,1,0,1.94,1.93A1.92,1.92,0,0,0,19,35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.11,35.65a2,2,0,1,0,2,2A2,2,0,0,0,45.11,35.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.09,8.84A21.4,21.4,0,1,0,53.48,30.23,21.4,21.4,0,0,0,32.09,8.84Zm9.15,7.68a6,6,0,1,1-6,6A6,6,0,0,1,41.24,16.52Zm-18.06-.25A6.22,6.22,0,1,1,17,22.49,6.22,6.22,0,0,1,23.18,16.27ZM19,41.91a4.22,4.22,0,1,1,4.22-4.22A4.22,4.22,0,0,1,19,41.91Zm13.46,8.51a6,6,0,1,1,6-6A6,6,0,0,1,32.47,50.42Zm12.7-8.51a4.22,4.22,0,1,1,4.22-4.22A4.22,4.22,0,0,1,45.17,41.91Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.47,
    cy: 44.45,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.18,
    cy: 22.49,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.24,
    cy: 22.49,
    r: 3.14
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgConnector4);
export default __webpack_public_path__ + "static/media/img_connector_4.672b3da3e7f1e02660bdbeef26589d7a.svg";
export { ForwardRef as ReactComponent };